import { PeopleCsvQuery } from './DownloadPeopleCSV.codegen'
import { t } from '@lingui/macro'

export const prepareCSVPeopleExport = (
  data: PeopleCsvQuery['analytics']['people']['usersOverview']
) =>
  data.map((row) => {
    const { user } = row
    return {
      [t`Email`]: user.email,
      [t`First name`]: user.first_name,
      [t`Last name`]: user.last_name,
      [t`Position`]: user.position,
      [t`Employee ID`]: user.employee_id,
      [t`Area`]: user.area,
      [t`Location`]: user.location,
      [t`Department`]: user.department,
      [t`Custom 1`]: user.custom_1,
      [t`Custom 2`]: user.custom_2,
      [t`Custom 3`]: user.custom_3,
      [t`Phone number`]: user.phone_number,
      [t`Account name`]: user.account_name,
      [t`Resource views count`]: row.resourceViewsCount,
      [t`Pathway enrolments count`]: row.pathwayEnrolmentsCount,
      [t`Attended events count`]: row.attendedEventsCount,
      [t`Workbooks count`]: row.workbooksCount,
      [t`Surveys count`]: row.surveysCount,
      [t`Certification enrolments count`]: row.certificationEnrolmentsCount,
      [t`Created at`]: user.created_at,
      [t`Created by id`]: user.created_by
    }
  })
